import { Empresa } from './../../models/empresa.model';
import { BuscadorPage } from './../buscador/buscador';
import { Component } from '@angular/core';
import { NavController, NavParams, LoadingController, MenuController } from 'ionic-angular';
import { VariablesGlobales } from '../../providers/variables-globales';
import { Consultas } from '../../providers/consultas';
import { RedSocial } from '../../models/redsocial.model';
import { Platform } from 'ionic-angular';
import { FileModel } from '../../models/files.model';

@Component({
  selector: 'page-empresa-single',
  templateUrl: 'empresa-single.html',
})

export class EmpresaSinglePage {
  public empresa: Empresa;
  public loader: any;
  public latitude:number;
  public longitude:number;
  public lat_empresa:number;
  public long_empresa:number;
  public slideData: Array<any>;

  constructor(public navCtrl: NavController,
    public navParams: NavParams,public consultas: Consultas,
     public loadingCtrl: LoadingController,
     public global: VariablesGlobales,
     public platform: Platform,public menuCtrl:MenuController) {
    this.empresa = navParams.get("empresa");
  }
  llamar(telefono){
    document.location.href = "tel:"+telefono;
  }
  goToWhatsapp(telefono:string){
    console.log(telefono.trim().split(' ').join('').replace("+",""));
    document.location.href = `https://api.whatsapp.com/send?phone=34${(telefono.trim().split(' ').join('').replace("+",""))}`;
  }
  goToBuscar(){
    this.navCtrl.push(BuscadorPage);
  }
  compartir(empresa:Empresa){
    const shareData = {
      title: empresa.nombre,
      text: empresa.nombre+"\n"+empresa.telefono+"\n\n\nhttps://guiapueblo.es",
    };
    navigator.share(shareData)
    .then((entries) => {
      console.log('success ' + JSON.stringify(entries));
    })
    .catch((error) => {
      alert('error ' + JSON.stringify(error));
      alert('error ' + error.message);
    });;
  }
  goToNavigation(){

    let destination = this.lat_empresa + ',' + this.long_empresa;
    let origin = this.latitude+","+this.longitude;
      if(this.platform.is('ios')){
        window.open('maps://?q=' + destination, '_system');
      } else {
        window.open("https://www.google.es/maps/dir/"+origin+"/"+destination+"/")
      }
  }
  goToRedSocial(redsocial){
    if(redsocial.includes("http://") || redsocial.includes("https://"))
      window.open(redsocial);
    else
    window.open("http://"+redsocial);
  }
  goToFile(file){
    window.open(VariablesGlobales.urlServidor + VariablesGlobales.empresasPdfs + file);
  }
  ionViewDidLoad() {
    console.log('ionViewDidLoad EmpresaSinglePage');
  }
  convertUrlToCoordenates(mapa){
    if(mapa) {
          if (mapa.includes("@")) {
              let aux = mapa.split("@");
              let aux2 = aux[1].split(",");
              this.lat_empresa = parseFloat(aux2[0]);
              this.long_empresa = parseFloat(aux2[1]);
          }
    }
  }
  ngOnInit(){
    this.loader = this.loadingCtrl.create();
    //Muestro el cargador mientras se cargan los productos
    this.loader.present().then(()=>{
      this.consultas.getEmpresa(this.empresa.id_empresa).subscribe(data=>{
        this.empresa = data[0][0] as Empresa;
        this.empresa.redesSociales = data[1] as Array<RedSocial>;
        this.empresa.pdfs = data[2] as Array<FileModel>;
        this.slideData = [this.empresa.imagen,this.empresa.imagen1,this.empresa.imagen2, this.empresa.imagen3, this.empresa.imagen4];
        this.agregarPdfsARedesSociales(data);
        this.agregarVideos(data);
        this.empresa.descripcion = this.empresa.descripcion.replace(/\n/gm,"<br>");

        this.convertUrlToCoordenates(this.empresa.maps);
        console.log("redes sociales");
        console.log(this.empresa.redesSociales);
        this.loader.dismiss();
      },error=>{
        console.log(error);
        if(this.loader){
          this.loader.dismiss();
        }
      });
    }).then(()=>{
      if (navigator && navigator.geolocation) {
        navigator.geolocation.getCurrentPosition((position)=>{
          console.log(position.coords.latitude)
          this.latitude = position.coords.latitude;
          this.longitude = position.coords.longitude;
        });
      }
    }).then(()=>{
      this.consultas.incrementarVisitasEmpresa(this.empresa.id_empresa).subscribe(console.log);
    });
  }

  agregarVideos(data){
    if(data[2] && data[2][0]){
      const videos = (<any>Object).entries(data[2][0])
      .filter(x=> !(x[1] as string).endsWith("pdf") && x[1])
      .map(x=> x[1]);
      console.log(videos)
      if(videos){

        this.empresa.videos = videos;
      }
    }
  }

  agregarPdfsARedesSociales(data){
    if(data[2] && data[2][0]){
      const pdfs = (<any>Object).entries(data[2][0])
      .filter(x=> (x[1] as string).endsWith("pdf"))
      .map(x=> {
          const pdf = new RedSocial();
          pdf.nombreRedSocial = x[0];
          pdf.linkRedSocial = x[1] as string;
          return pdf;
      });
        if(this.empresa.redesSociales)
          this.empresa.redesSociales = this.empresa.redesSociales.concat(pdfs)
        else
          this.empresa.redesSociales = pdfs;
    }
  }

  toggleMenu() {
    this.menuCtrl.toggle();
  }
}



// WEBPACK FOOTER //
// ./src/pages/empresa-single/empresa-single.ts